const getUpcomingClassesFilters = (filters) => {
  return {
    ...filters,
    category: filters.category || undefined,
    gender: filters.gender === '_' ? undefined : filters.gender,
    languages: filters.languages === '_' ? undefined : filters.languages,
    country_of_origin: filters.country_of_origin === '_' ? undefined : filters.country_of_origin,
    country_of_residence:
      filters.country_of_residence === '_' ? undefined : filters.country_of_residence,
    search: filters.search || undefined,
  }
}

export default getUpcomingClassesFilters
